import { parseTelemetry, TelemetryEvent } from "@nova/telemetry-parsing"
import { VideoMetadata } from "@nova/slice-video"
import { fileToString } from "tools/browser/file"

export const toVideoMetadata = (events: TelemetryEvent[]) =>
    events.map((e) => [
        e.longitude,
        e.latitude,
        e.elevation ?? NaN,
        e.pitch,
        e.yaw,
        e.roll,
        e.fov ?? NaN,
        e.height,
    ]) as VideoMetadata

export const parseTelemetryFile = async (file?: File) => {
    if (!file) return
    const text = await fileToString(file)
    return toVideoMetadata(parseTelemetry(text))
}
